import { withNamespaces } from "react-i18next";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";

const DeleteConfirmationModal = ({
    isOpen,
    isDeleting,
    onClose,
    onConfirm,
    t,
}) => {
    return (
        <Modal isOpen={isOpen} toggle={isDeleting ? undefined : onClose} centered>
            <ModalHeader toggle={isDeleting ? undefined : onClose}>
                {t("Confirm Deletion")}
            </ModalHeader>
            <ModalBody>
                {t("Are you sure you want to delete this data flow?")}
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    outline
                    type="button"
                    onClick={onClose}
                    disabled={isDeleting}
                >
                    {t("Cancel")}
                </Button>
                <Button
                    color="danger"
                    type="button"
                    onClick={onConfirm}
                    disabled={isDeleting}
                >
                    {isDeleting ? <Spinner size="sm" /> : t("Delete")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(DeleteConfirmationModal);
